import EpisodeDuration from './EpisodeDuration';

export default EpisodeDuration;
